import { render, staticRenderFns } from "./BetonSingle.vue?vue&type=template&id=0508b47e&scoped=true&"
import script from "./BetonSingle.vue?vue&type=script&lang=js&"
export * from "./BetonSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508b47e",
  null
  
)

export default component.exports